import * as env from 'src/lib/env';
import type { DeviceType } from 'src/lib/userAgent';

import { openOAuthPopup } from './utils';

const AUTH_URL = `${env.getBackendUrl()}/authentication/google_oauth2`;

// The backend defines the same text as GENERIC_AUTH_ERROR_MESSAGE and sends it in error_message.
export const GOOGLE_SIGN_IN_ERROR_MESSAGE =
  'Something went wrong while signing you in. Please try again.';

// The backend sends this error_code when the callback's state did not match. A resubmitted callback is the usual cause.
export const GOOGLE_STATE_MISMATCH_ERROR_CODE = 'state_mismatch';

const formatGoogleSignupUrl = (state: string, signUpDevice: DeviceType) =>
  AUTH_URL.concat('?state=', encodeURIComponent(state), '&signUpDevice=', signUpDevice);

export const loginToGoogle = (state: string, signUpDevice: DeviceType) => {
  const authUrl = formatGoogleSignupUrl(state, signUpDevice);

  return openOAuthPopup(authUrl);
};
